export { default } from './MentionedInQuizStep';
